import styled from 'styled-components';
import { media } from '../../styles/theme';

export const Container = styled.header`
  grid-area: header;
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.lg};
  padding: 0 ${({ theme }) => theme.espaco.lg};
  background-color: ${({ theme }) => theme.cores.primary};
  color: ${({ theme }) => theme.cores.inkInverse};
  border-bottom: 1px solid ${({ theme }) => theme.cores.borderInverse};
  z-index: ${({ theme }) => theme.zIndex.header};

  ${media.mobile} {
    padding: 0 ${({ theme }) => theme.espaco.sm};
    gap: ${({ theme }) => theme.espaco.sm};
  }

  @media print {
    display: none;
  }
`;

export const Logo = styled.img`
  height: 30px;
  width: auto;
  flex-shrink: 0;

  ${media.mobile} {
    height: 28px;
    margin: 0 auto;
  }
`;

// Botão só com ícone sobre o navy (hambúrguer, sair)
export const BotaoIcone = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 44px;
  height: 44px;
  border: none;
  border-radius: ${({ theme }) => theme.raio.md};
  background: transparent;
  color: ${({ theme }) => theme.cores.inkInverse};

  /* Só com mouse: no toque o :hover fica preso depois do clique */
  @media (hover: hover) {
    &:hover {
      background-color: ${({ theme }) => theme.cores.primarySoft};
      color: ${({ theme }) => theme.cores.accent};
    }
  }

  &:active {
    background-color: ${({ theme }) => theme.cores.primarySoft};
  }
`;

export const SoMobile = styled.div`
  display: none;

  ${media.mobile} {
    display: contents;
  }
`;

export const SoDesktop = styled.div`
  display: contents;

  ${media.mobile} {
    display: none;
  }
`;

export const Menu = styled.nav`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.xs};
  flex: 1;
  min-width: 0;
`;

export const MenuItem = styled.div`
  position: relative;

  &:hover > div,
  &:focus-within > div {
    display: block;
  }
`;

export const MenuBotao = styled.button`
  display: inline-flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.sm};
  height: 40px;
  padding: 0 ${({ theme }) => theme.espaco.md};
  border: none;
  border-radius: ${({ theme }) => theme.raio.md};
  background: transparent;
  color: ${({ theme }) => theme.cores.inkInverse};
  font-weight: 500;
  white-space: nowrap;

  ${MenuItem}:hover > &,
  ${MenuItem}:focus-within > & {
    background-color: ${({ theme }) => theme.cores.primarySoft};
    color: ${({ theme }) => theme.cores.accent};
  }

  .seta {
    opacity: 0.7;
  }
`;

export const Dropdown = styled.div`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  min-width: 220px;
  padding: ${({ theme }) => theme.espaco.xs};
  background-color: ${({ theme }) => theme.cores.primaryHover};
  border: 1px solid ${({ theme }) => theme.cores.borderInverse};
  border-radius: ${({ theme }) => theme.raio.md};
  box-shadow: ${({ theme }) => theme.sombra.dropdown};
  z-index: ${({ theme }) => theme.zIndex.dropdown};
`;

export const DropdownItem = styled.div`
  position: relative;

  &:hover > div,
  &:focus-within > div {
    display: block;
  }
`;

export const DropdownBotao = styled.button`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.espaco.sm};
  width: 100%;
  min-height: 38px;
  padding: 0 ${({ theme }) => theme.espaco.md};
  border: none;
  border-radius: ${({ theme }) => theme.raio.sm};
  background: transparent;
  color: ${({ theme }) => theme.cores.inkInverse};
  text-align: left;
  white-space: nowrap;

  span {
    flex: 1;
  }

  &:hover,
  ${DropdownItem}:focus-within > & {
    background-color: ${({ theme }) => theme.cores.primarySoft};
    color: ${({ theme }) => theme.cores.accent};
  }
`;

export const SubDropdown = styled(Dropdown)`
  left: 100%;
  top: -5px;
`;
